import gql from "graphql-tag";

export default gql`query MessageStats {
    messageStats
  }`